module.exports = __webpack_public_path__ + "static/img/4.c507f7f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/1/eng/4.png
// module id = Q3+1
// module chunks = 0